import { mapGetters } from 'vuex';
import mvtPopSignin from '@/common/components/mvtpopsignin/mvt-popsignin.vue';
import ThumbtackResultsList from '../components/thumbtackresultslist/thumbtackresultslist.vue';
import ThumbtackSearch from '../components/thumbtacksearch/thumbtacksearch.vue';
import mvtInputGeo from '@/common/components/mvtinputgeo/mvt-inputgeo.vue';
import mvtWelcome from '@/common/components/mvtwelcome/mvt-welcome.vue';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';

export default {
    name: 'homeservicesLanding',
    inject: ['$eventBus'],
    components: {
        mvtPopSignin,
        mvtHeader,
        mvtFooter,
        mvtDialogCenter,
        ThumbtackResultsList,
        ThumbtackSearch,
        mvtInputGeo,
        mvtWelcome,
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        getHeaderText() {
            return {
                text1: 'Find the pros you need to get things done!',
                text2: 'Search vetted companies in',
                utm_content: 'v3',
            };
        },
    },
    data() {
        return {
            state: '',
            city: '',
            search: {
                query: null,
                zipCode: null,
                utm_medium: null,
                utm_campaign: null,
                utm_source: null,
            },
            isLoading: false,
            providers: [],
            geoInfo: {
                text: '',
                geo: null,
            },
            popularSearches: [
                {
                    title: 'TV Mounting',
                    image: 'tv-mounting@2x.jpg',
                    search: 'tv mounting',
                },
                {
                    title: 'Movers',
                    image: 'movers@2x.jpg',
                    search: 'movers',
                },
                {
                    title: 'House Cleaning',
                    image: 'house-cleaning@2x.jpg',
                    search: 'house cleaning',
                },
                {
                    title: 'Junk Removal',
                    image: 'junk-removal@2x.jpg',
                    search: 'junk removal',
                },
            ],
            topCategories: [
                {
                    title: 'Plumbing',
                    image: 'plumbing.jpg',
                    search: 'plumbing',
                },
                {
                    title: 'Heating & Cooling',
                    image: 'heating-cooling.jpg',
                    search: 'heating and cooling',
                },
                {
                    title: 'Roofing',
                    image: 'roofing.jpg',
                    search: 'roofing',
                },
                {
                    title: 'Landscaping',
                    image: 'landscaping.jpg',
                    search: 'landscaping',
                },
                {
                    title: 'Electrical',
                    image: 'electrical.jpg',
                    search: 'electrical',
                },
                {
                    title: 'Carpentry',
                    image: 'carpentry.jpg',
                    search: 'carpentry',
                },
                {
                    title: 'Concrete & Masonry',
                    image: 'concrete-masonry.jpg',
                    search: 'concrete and masonry',
                },
                {
                    title: 'Drywall & Insulation',
                    image: 'drywall-insulation.jpg',
                    search: 'drywall and insulation',
                },
                {
                    title: 'Flooring',
                    image: 'flooring.jpg',
                    search: 'flooring',
                },
                {
                    title: 'Windows & Doors',
                    image: 'windows-doors.jpg',
                    search: 'windows and doors',
                },
            ],
        };
    },
    methods: {
        getSearchURL(category) {
            let url = `${this.glb.appUrl}homeservices/search/?query=${encodeURIComponent(category.search)}${this.search.zipCode ? '&zip_code=' + this.search.zipCode : ''}`;
            return this.appendUTMParams(url);
        },
        appendUTMParams(url) {
            if (this.search.utm_medium) {
                url += `&utm_medium=${this.search.utm_medium}`;
            }
            if (this.search.utm_campaign) {
                url += `&utm_campaign=${this.search.utm_campaign}`;
            }
            if (this.search.utm_source) {
                url += `&utm_source=${this.search.utm_source}`;
            }
            if (this.getHeaderText.utm_content) {
                url += `&utm_content=${this.getHeaderText.utm_content}`;
            }
            return url;
        },
        onSubmit() {
            // this.$router.push("/homeservices/search/?query=" + this.search.query + "&zip_code=" + this.search.zipCode);
            let url = this.glb.appUrl + 'homeservices/search/?query=' + this.search.query + '&zip_code=' + this.search.zipCode;
            window.location.href = this.appendUTMParams(url);
        },
    },
    watch: {
        geoInfo(newVal, oldVal) {
            if (newVal && newVal.text && newVal.text !== oldVal.text) {
                this.$eventBus.$emit('eventbus-claimed-home', newVal);
            }
        },
    },
    mounted() {
        const query = this.$route.query.query;
        const zipCode = this.$route.query['zip_code'];
        const city = this.$route.query.city;
        const state = this.$route.query.state;

        if (zipCode) {
            this.search.zipCode = decodeURIComponent(zipCode);
        }

        if (city && state) {
            this.city = decodeURIComponent(city);
            this.state = decodeURIComponent(state);
        }

        if (query) {
            this.search.query = decodeURIComponent(query);
        }

        this.search.utm_medium = this.$route.query.utm_medium || null;
        this.search.utm_campaign = this.$route.query.utm_campaign || null;
        this.search.utm_source = this.$route.query.utm_source || null;

        if (this.glb.homeservices) {
            if (!this.search.zipCode) {
                this.search.zipCode = this.glb.homeservices.zipCode;
            }

            if (!this.city && !this.state) {
                this.city = this.glb.homeservices.city;
                this.state = this.glb.homeservices.state;
            }
        }
    },
};
